import React from 'react';
var VeltCommentBubbleAvatar = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-bubble-avatar-wireframe", null, children));
};
export default VeltCommentBubbleAvatar;
